import { useState, useRef } from "preact/hooks";
import { SearchTermsFacet } from "@nosto/nosto-js/client";
import FilterTrigger from "../FilterTrigger/FilterTrigger";
import Checkbox from "@/elements/Checkbox/Checkbox";
import { useOptimisticFacet } from "@/hooks/useOptimisticFacet";

type Props = {
  facet: SearchTermsFacet;
};

export default function TermsDropdown({ facet }: Props) {
  const { optimisticData, toggleProductFilter } = useOptimisticFacet(facet);

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Keyboard support
  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setIsOpen((prev) => !prev);
    } else if (e.key === "Escape") {
      setIsOpen(false);
    }
  };

  return (
    <div
      ref={dropdownRef}
      className="filter-facets__nav-item"
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <FilterTrigger
        value={facet.name}
        isOpen={isOpen}
        onKeyDown={handleKeyDown}
        ariaLabel={`Filter by ${facet.name}`}
      />

      {isOpen && (
        <div className="filter-facets__nav-item-options" role="menu">
          {optimisticData.map((data) => (
            <div key={data.value} role="menuitem">
              <Checkbox
                value={`${data.value} (${data.count})`}
                label={data.value}
                count={data.count}
                selected={data.selected}
                onChange={(e) => {
                  e.preventDefault();
                  toggleProductFilter(facet.field, data.value, !data.selected);
                }}
                visual={data.visual}
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
